import { useOptionalCurrentAgencyUser } from '@oysterjs/ais/components/current-user';
import { FEATURE_FLAGS, useFlag } from '@oysterjs/ais/components/feature-flags';

/**
 * The dashboard loader resolves availability before cards or deep links render.
 * The admin app embeds Conversation without a CurrentUserProvider, so no
 * provider means no mailbox, as it means every flag is off in useFeatureFlags.
 */
export const useMailboxComposerEnabled = () => {
  const agencyUser = useOptionalCurrentAgencyUser();
  const mailboxFlagEnabled = useFlag(FEATURE_FLAGS.MAILBOX);
  return mailboxFlagEnabled && Boolean(agencyUser?.hasAccessibleMailbox);
};
